import { render, staticRenderFns } from "./TranslateButton.vue?vue&type=template&id=cc904c52&scoped=true"
import script from "./TranslateButton.vue?vue&type=script&lang=js"
export * from "./TranslateButton.vue?vue&type=script&lang=js"
import style0 from "./TranslateButton.vue?vue&type=style&index=0&id=cc904c52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc904c52",
  null
  
)

export default component.exports